/**
 * this is added for https://wandb.atlassian.net/browse/WB-16553
 * number chosen is non-scientific, so may be able to be adjusted
 */
export const MAX_VISIBLE_LINE_LENGTH = 5000;
export const MIN_ROW_HEIGHT = 22; // should match the line-height
export const TRUNCATED_LABEL_MAX_CHARS = 16;
export const REGEX_RUN_ID =
  /WANDB_PROJECT='(.*)'.*WANDB_ENTITY=([a-z0-9\-_]*).*WANDB_RUN_ID=([a-z0-9]+)/;
export const UNLABELED = 'Unlabeled';
export const OUTER_PADDING = 16;
